import { utils } from '@snsw/react-component-library';
import { useMemo } from 'react';

const { detectDragDrop } = utils;
export const useDetectHasDragDrop = () => useMemo(() => detectDragDrop(), []);
